import basePageFields from '@fragments/pages/basePageFields';

import ImageSummaryFragment from '@fragments/summaries/ImageSummaryFragment';
import ContentDynamicSortableFragment from '@fragments/shared/ContentDynamicSortableFragment';

export default gql`
    fragment ResearchLandingFragment on ResearchLanding {
        ${basePageFields}
        dek
        accentColor
        newsletter {
            id
            newsletter {
                title
                dek
                hero {
                    image {
                        ...ImageSummaryFragment
                    }
                }
            }
            newsletterFormName
        }
        researchHeroContent {
            ...ContentDynamicSortableFragment
        }
        recentArticlesAndPapers {
            ...ContentDynamicSortableFragment
        }
        recentlyPublished {
            ...ContentDynamicSortableFragment
        }
    }

    ${ImageSummaryFragment}
    ${ContentDynamicSortableFragment}
`;
